module.exports = __webpack_public_path__ + "img/detailedlist_20pt_checked.570b388d.svg";